export interface Loading {
    startLoading?: boolean;
    stopLoading?: boolean;
    load?: boolean;
}

export class Loading {

    constructor(init?: boolean) {
        this.startLoading = true;
        this.stopLoading = true;
        this.load = init;
    }
}